var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplay01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83526 3.10464H15.1798L14.6451 2.56994C14.1753 2.10005 14.1753 1.32231 14.6451 0.852417C15.115 0.382528 15.8928 0.382528 16.3627 0.852417L18.9066 3.3963C19.3764 3.86619 19.3764 4.64394 18.9066 5.11383L16.3627 7.65771C16.1196 7.90076 15.8118 8.01418 15.5039 8.01418C15.196 8.01418 14.8882 7.90076 14.6451 7.65771C14.1753 7.18782 14.1753 6.41007 14.6451 5.94018L15.0664 5.5189H6.83526C4.76126 5.5189 3.05994 7.20402 3.05994 9.29422C3.05994 11.3844 4.74506 13.0695 6.83526 13.0695H14.8072C15.4715 13.0695 16.0224 13.6204 16.0224 14.2848C16.0224 14.9491 15.4715 15.5 14.8072 15.5H6.83526C3.41641 15.5 0.629478 12.7131 0.629478 9.29422C0.629478 5.87537 3.41641 3.10464 6.83526 3.10464Z",
    fill: "#234CE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay01);
export default __webpack_public_path__ + "static/media/replay-01.2005222a15b201671b5405c3e95567b4.svg";
export { ForwardRef as ReactComponent };